import dynamic from 'next/dynamic';
import { wfbAdsLoading as loading } from './WfbAdsLoader';

const DynamicFeaturedEmployerCards = dynamic(() => import(
  './FeaturedEmployerCards'
), {
  ssr: false,
  loading,
});

export default DynamicFeaturedEmployerCards;
